import React, { Component } from 'react';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import PortletContent from 'components/PortletContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withTranslation } from 'react-i18next';

class NoActive extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { classes, t } = this.props;

    return (
      <PortletContent className={classes.root} >

        <Grid container wrap="nowrap" spacing={2}>
          <Grid item xs>
            <Typography className={classes.textGrey}>
              {t("helpers.section.noActive")}
            </Typography>
          </Grid>
        </Grid>
      </PortletContent>

    );

  }

}


export default compose(withRouter, withTranslation(), withStyles(styles))(NoActive);